<template>
  <div class="projects">
    <div class="section-header">
      <div class="section-title">我的项目</div>
    </div>
    <div v-loading="projectsLoading" class="projects-grid">
      <div v-for="project in projects" :key="project.id" class="project-card">
        <el-card shadow="hover" :body-style="{ padding: '0' }">
          <div class="project-image" :style="getCoverStyle(project.coverImage)"></div>
          <div class="project-content">
            <div class="project-title">{{ project.title }}</div>
<!--            <div class="project-progress">-->
<!--              <div class="progress-label">课时进度</div>-->
<!--              <el-progress :percentage="project.progress" :stroke-width="8" :color="project.progress === 100 ? '#67c23a' : '#409eff'" />-->
<!--              <div class="progress-value">{{ project.progress }}%</div>-->
<!--            </div>-->
            <div class="project-actions">
              <el-button
                type="info"
                plain
                size="small"
                @click="goProjectDetail(project)"
              >
                详情
              </el-button>
              <el-button
                v-if="project.canRegister"
                type="primary"
                size="small"
                :loading="registeringProjectId === project.projectId"
                :disabled="registeringProjectId === project.projectId"
                @click="handleRegisterProject(project)"
              >
                去报名
              </el-button>
              <el-button
                v-if="!project.canRegister"
                type="primary"
                plain
                size="small"
                :loading="scoreLoadingProjectId === project.projectId"
                :disabled="scoreLoadingProjectId === project.projectId"
                @click="showScoreDialog(project)"
              >
                查看成绩
              </el-button>
              <el-button
                v-if="!project.canRegister"
                type="primary"
                size="small"
                :loading="certificateLoadingProjectId === project.projectId"
                :disabled="certificateLoadingProjectId === project.projectId"
                @click="showCertificateDialog(project)"
              >
                查看证书
              </el-button>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div v-if="projectsTotal > projectsQuery.pageSize" class="pagination">
      <el-pagination
        layout="prev, pager, next"
        :total="projectsTotal"
        :page-size="projectsQuery.pageSize"
        :current-page="projectsQuery.pageNum"
        prev-text="<"
        next-text=">"
        @current-change="handleCurrentChange"
      />
    </div>
    
    <!-- 证书弹窗组件 -->
    <CertificateDialog
      :visible.sync="certificateDialogVisible"
      :certificate-name="selectedCertificate.name"
      :certificate-number="selectedCertificate.number"
    />
    
    <!-- 成绩弹窗组件 -->
    <ScoreDialog
      :visible.sync="scoreDialogVisible"
      :project-name="selectedScore.projectName"
      :score="selectedScore.score"
      :exam-time="selectedScore.examTime"
      :passing-score="selectedScore.passingScore"
    />

  </div>
</template>

<script>
import CertificateDialog from '@/components/CertificateDialog.vue'
import ScoreDialog from '@/components/ScoreDialog.vue'
import { mapGetters } from 'vuex'
import { getMyProjects, getProjectCertificate, getProjectScore, registerProject } from '@/api/authApi'

export default {
  name: 'AppProjects',
  components: {
    CertificateDialog,
    ScoreDialog
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'userInfo', 'isRealNameVerified'])
  },
  created() {
    this.loadProjects()
  },
  data() {
    return {
      certificateDialogVisible: false,
      selectedCertificate: {
        name: '',
        number: ''
      },
      scoreDialogVisible: false,
      selectedScore: {
        projectName: '',
        score: 0,
        examTime: '',
        passingScore: 60
      },
      projectsLoading: false,
      projectsTotal: 0,
      projectsQuery: {
        pageNum: 1,
        pageSize: 10,
        projectName: undefined
      },
      projects: [],
      registeringProjectId: null,
      scoreLoadingProjectId: null,
      certificateLoadingProjectId: null
    }
  },
  methods: {
    extractListAndTotal(data) {
      const list =
        (Array.isArray(data) && data) ||
        (data && Array.isArray(data.list) && data.list) ||
        (data && Array.isArray(data.records) && data.records) ||
        (data && Array.isArray(data.items) && data.items) ||
        []

      const total =
        (data && (data.total ?? data.count ?? data.totalCount)) ||
        (typeof data === 'object' && !Array.isArray(data) ? list.length : list.length)

      return { list, total: Number(total) || 0 }
    },
    normalizeMyProject(item, index) {
      const p = item || {}
      const projectId = p.projectId
      const id = projectId != null ? Number(projectId) : index
      const title = String(p.projectName || (projectId != null ? `项目 ${projectId}` : '项目'))

      const isRegistered = Boolean(p.isRegistered)
      const status = isRegistered ? '已报名' : '未报名'

      const markStatusNum = p.markStatus != null ? Number(p.markStatus) : undefined
      const progressMap = {
        1: 10,
        2: 30,
        3: 55,
        4: 75,
        5: 90,
        6: 100
      }
      const certificateNo = p.certificateNo
      const hasCertificate = Boolean(certificateNo)
      const progress = hasCertificate ? 100 : (isRegistered ? (progressMap[markStatusNum] ?? 0) : 0)

      const description = String(p.subtitle || p.description || '')

      return {
        id,
        projectId: projectId != null ? Number(projectId) : undefined,
        title,
        description,
        coverImage: String(p.coverImage || ''),
        status,
        tagType: isRegistered ? 'success' : 'info',
        canRegister: !isRegistered,
        hasCertificate,
        progress,
        raw: p,
        certificateNo,
        score: p.score != null ? Number(p.score) : undefined,
        registrationTime: String(p.registrationTime || '')
      }
    },
    backToCourses() {
      if (this.$route && this.$route.name === 'memberProjects') {
        this.$router.push('/member-center/courses')
        return
      }
      this.$emit('back-to-courses')
    },
    async loadProjects() {
      if (this.projectsLoading) return
      this.projectsLoading = true
      try {
        const res = await getMyProjects(this.projectsQuery)
        const data = res && res.data
        const { list, total } = this.extractListAndTotal(data)
        this.projects = list.map((it, idx) => this.normalizeMyProject(it, idx))
        this.projectsTotal = total
      } catch (err) {
        this.projects = []
        this.projectsTotal = 0
        this.$message.error((err && err.message) || '获取项目列表失败')
      } finally {
        this.projectsLoading = false
      }
    },
    handleCurrentChange(val) {
      this.projectsQuery.pageNum = val
      this.loadProjects()
    },
    getCoverStyle(url) {
      const u = String(url || '').trim()
      if (!u) return undefined
      return {
        backgroundImage: `url(${u})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    },
    async handleRegisterProject(project) {
      const p = project || {}
      const projectId = p.projectId
      if (projectId == null || projectId === '') {
        this.$message.error('缺少项目ID')
        return
      }
      if (!this.isLoggedIn) {
        this.$message.warning('请先登录')
        return
      }
      if (!this.isRealNameVerified) {
        this.forceRealNameVerification()
        return
      }
      if (this.registeringProjectId != null) return
      try {
        await this.$confirm(`确认报名「${p.title || '该项目'}」吗？`, '确认报名', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      this.registeringProjectId = projectId
      try {
        await registerProject(projectId)
        this.$message.success('报名成功')
        await this.loadProjects()
      } catch (err) {
        this.$message.error((err && err.message) || '报名失败')
      } finally {
        this.registeringProjectId = null
      }
    },
    async forceRealNameVerification() {
      try {
        await this.$confirm('报名前需要完成实名认证，是否现在去实名认证？', '实名认证提醒', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning'
        })
        this.$router.push('/member-center/settings')
      } catch (e) {
        // 用户取消
      }
    },
    goProjectDetail(project) {
      const p = project || {}
      const projectId = p.projectId
      if (projectId == null || projectId === '') {
        this.$message.error('缺少项目ID')
        return
      }
      this.$router.push({ name: 'projectDetail', params: { id: projectId } })
    },
    async showScoreDialog(project) {
      const p = project || {}
      const projectId = p.projectId
      if (projectId == null || projectId === '') {
        this.$message.error('缺少项目ID')
        return
      }
      if (this.scoreLoadingProjectId != null) return
      this.scoreLoadingProjectId = projectId
      try {
        const res = await getProjectScore(projectId)
        const data = res && res.data
        this.selectedScore = {
          projectName: p.title || '',
          score: data && data.score != null ? Number(data.score) : 0,
          examTime: String((data && (data.updateTime || data.registrationTime || data.createTime)) || ''),
          passingScore: 60
        }
        this.scoreDialogVisible = true
      } catch (err) {
        this.$message.error((err && err.message) || '获取成绩失败')
      } finally {
        this.scoreLoadingProjectId = null
      }
    },
    // 显示证书弹窗
    async showCertificateDialog(project) {
      const p = project || {}
      const projectId = p.projectId
      if (projectId == null || projectId === '') {
        this.$message.error('缺少项目ID')
        return
      }
      if (this.certificateLoadingProjectId != null) return
      this.certificateLoadingProjectId = projectId
      try {
        const res = await getProjectCertificate(projectId)
        const data = res && res.data
        this.selectedCertificate = {
          name: p.title,
          number: String((data && data.certificateNo) || '')
        }
        this.certificateDialogVisible = true
      } catch (err) {
        this.$message.error((err && err.message) || '获取证书失败')
      } finally {
        this.certificateLoadingProjectId = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.projects {
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8e8e8;

    .section-title {
      font-size: 20px;
      font-weight: 600;
      color: #3E2CCD;

    }
  }

  .section-header-secondary {
    margin-top: 22px;
  }

  .projects-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    margin-top: 16px;
  }

  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }

  .project-card {
    height: 100%;
  }

  .project-image {
    height: 120px;
    background-color: #3579f7;
  }

  .project-content {
    padding: 12px;
  }

  .project-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .project-description {
    font-size: 14px;
    color: #606266;
    margin-bottom: 12px;
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .project-progress {
    margin-bottom: 16px;
  }

  .progress-label {
    font-size: 14px;
    color: #606266;
    margin-bottom: 8px;
  }

  .progress-value {
    font-size: 12px;
    color: #909399;
    text-align: right;
    margin-top: 4px;
  }

  .project-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 10px;
    
    .el-button {
      flex: 1;
      margin-left: 0;
    }
  }
  
  /* 提醒弹窗样式 */
  .reminder-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
  }
  
  .reminder-icon {
    margin-bottom: 20px;
  }
  
  .reminder-text {
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  
  .reminder-text p {
    margin: 10px 0;
  }
  
  .reminder-checkbox {
    margin-top: 10px;
    align-self: flex-start;
  }
}
</style>
